export class ListSaasEntitiesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListSaasEntitiesRequestFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitiesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
